import { render, staticRenderFns } from "./TipoDispositivoForm.vue?vue&type=template&id=892771bc&scoped=true&"
import script from "./TipoDispositivoForm.vue?vue&type=script&lang=ts&"
export * from "./TipoDispositivoForm.vue?vue&type=script&lang=ts&"
import style0 from "./TipoDispositivoForm.vue?vue&type=style&index=0&id=892771bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "892771bc",
  null
  
)

export default component.exports